import { Operation } from 'src/app/core/_models/operation';
import { ProductOperation } from 'src/app/core/_models/productOperation';
import { Project } from 'src/app/core/_models/project';

export function computeOperationHasError(operation: Operation): boolean {
  const inputProducts = operation.detailedOperation?.inputProducts;
  const outputProducts = operation.detailedOperation?.outputProducts;
  const vehicles = operation.detailedOperation?.vehicles;

  const productErr = (p: ProductOperation) => p.resourceNotAvailableForThisVersion || p.productIsDeleted || p.transportIsDeleted || p.energyIsDeleted || (!!p.transportId && p.transportationNotAvailableForThisVersion);
  const inputErr = inputProducts?.some(productErr);
  const outputErr = outputProducts?.some(productErr);
  const vehicleErr = vehicles?.some((v) => v.resourceNotAvailableForThisVersion || v.transportIsDeleted);

  return Boolean(inputErr || outputErr || vehicleErr);
}

export function computeProjectErrors(project: Project | undefined | null): boolean {
  if (!project?.solutions) return false;

  let projectHasError = false;

  project.solutions.forEach((solution) => {
    let solutionHasError = false;
    solution.operations?.forEach((operation) => {
      operation.hasError = computeOperationHasError(operation);
      if (operation.hasError) solutionHasError = true;
    });
    solution.hasError = solutionHasError;
    if (solutionHasError) projectHasError = true;
  });

  return projectHasError;
}
